module.exports = __webpack_public_path__ + "static/zoe-web-arm@2x-d628c82ffce33111a053811753d80df7.jpg";